import React from 'react';
import { Row, Col, Form, Card, Button, Spinner, Alert, Badge } from 'react-bootstrap';

// imports sonrası, component öncesi
const cleanTextInput = (value, removeSpaces = false) => {
    let cleaned = value.trim().toUpperCase();
    if (removeSpaces) {
        cleaned = cleaned.replace(/\s+/g, '');
    }
    return cleaned;
};

/**
 * ERP Odaklı Fiyat Bilgileri Formu - Compact Version
 * Alış/Satış fiyatları ve tarihleri, Satıcı/Alıcı bilgileri
 */
const VehiclePriceForm = ({
    data,
    handleChange,
    disabled,
    getFieldHighlightClass,
    // Search props with default values
    foundSupplier = null,
    supplierSearchError = null,
    searchingSupplier = false,
    handleSearchSupplier = () => { },
    foundCustomer = null,
    customerSearchError = null,
    searchingCustomer = false,
    handleSearchCustomer = () => { }
}) => {


    const getFieldClasses = (fieldName, additionalClasses = '') => {
        const highlightClass = getFieldHighlightClass ? getFieldHighlightClass(fieldName) : '';
        const baseClasses = additionalClasses || 'form-control';
        return `${baseClasses} ${highlightClass}`.trim();
    };

    return (
        <Card className="mb-4">
            <Card.Header>
                <h5 className="mb-0">💰 Fiyat Bilgileri & Alım-Satım</h5>
            </Card.Header>
            <Card.Body>
                {/* ✅ Fiyat ve Tarih Bilgileri - Tek Satırda */}
                <Row className="mb-4">
                    <Col md={3}>
                        <Form.Group className="mb-3">
                            <Form.Label>Alış Fiyatı (₺)</Form.Label>
                            <Form.Control
                                type="number"
                                name="purchasePrice"
                                value={data.purchasePrice || ''}
                                onChange={handleChange}
                                placeholder="0"
                                min="0"
                                step="1"
                                required
                                className={getFieldClasses('purchasePrice')}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={3}>
                        <Form.Group className="mb-3">
                            <Form.Label>Satış Fiyatı (₺)</Form.Label>
                            <Form.Control
                                type="number"
                                name="salePrice"
                                value={data.salePrice || ''}
                                onChange={handleChange}
                                placeholder="0"
                                min="0"
                                step="1"
                                className={getFieldClasses('salePrice')}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={3}>
                        <Form.Group className="mb-3">
                            <Form.Label>Alış Tarihi <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="date"
                                name="purchaseDate"
                                value={data.purchaseDate || ''}
                                onChange={handleChange}
                                required
                                className={getFieldClasses('purchaseDate')}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={3}>
                        <Form.Group className="mb-3">
                            <Form.Label>Satış Tarihi</Form.Label>
                            <Form.Control
                                type="date"
                                name="saleDate"
                                value={data.saleDate || ''}
                                onChange={handleChange}
                                className={getFieldClasses('saleDate')}
                            />
                            <Form.Text className="text-muted">İsteğe bağlı</Form.Text>
                        </Form.Group>
                    </Col>
                </Row>

                {/* ✅ Fatura Bilgileri - OCR ile otomatik dolu */}
                <Row className="mb-4">
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>📄 Fatura Numarası</Form.Label>
                            <Form.Control
                                type="text"
                                name="invoiceNumber"
                                value={data.invoiceNumber || ''}
                                onChange={handleChange}
                                placeholder="OCR ile otomatik doldurulacak"
                                className={getFieldClasses('invoiceNumber')}
                                readOnly={!data.invoiceNumber} // OCR ile dolmadıysa read-only
                            />
                            <Form.Text className="text-muted">
                                {data.invoiceNumber ? 'Fatura OCR ile çıkarıldı - değiştirilebilir' : 'Alış faturası yüklendiğinde otomatik doldurulur'}
                            </Form.Text>
                        </Form.Group>
                    </Col>
                </Row>

                {/* ✅ Satıcı Bilgileri - Compact */}
                <div className="border-top pt-3 mb-4">
                    <h6 className="mb-3">👤 Satıcı Bilgileri (Kimden Alındı)</h6>

                    {/* *** YENİ: Kimlik Türü Seçimi *** */}
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Kimlik Türü *</Form.Label>
                        <div className="d-flex gap-3 mt-2">
                            <Form.Check
                                type="radio"
                                id="supplier-identity-tckn"
                                name="supplierIdentityType"
                                label="T.C. Kimlik No"
                                checked={data.supplierIdentityType === 'TCKN'}
                                onChange={() => {
                                    const event = { target: { name: 'supplierIdentityType', value: 'TCKN' } };
                                    handleChange(event);
                                }}
                            />
                            <Form.Check
                                type="radio"
                                id="supplier-identity-vkn"
                                name="supplierIdentityType"
                                label="Vergi Kimlik No"
                                checked={data.supplierIdentityType === 'VKN'}
                                onChange={() => {
                                    const event = { target: { name: 'supplierIdentityType', value: 'VKN' } };
                                    handleChange(event);
                                }}
                            />
                        </div>
                    </Form.Group>

                    <Row>
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>Satıcı Adı <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="purchasedFrom.name"
                                    value={data.purchasedFrom?.name || ''}
                                    onChange={(e) => {
                                        const value = e.target.value.toUpperCase();
                                        handleChange({
                                            target: {
                                                name: 'purchasedFrom.name',
                                                value: value
                                            }
                                        });
                                    }}
                                    placeholder="Satıcı adı"
                                    className={getFieldClasses('purchasedFrom.name')}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    {data.supplierIdentityType === 'TCKN' ? 'T.C. Kimlik No' : 'Vergi Kimlik No'} <span className="text-danger">*</span>
                                </Form.Label>
                                <div className="d-flex gap-2">
                                    <Form.Control
                                        type="text"
                                        value={data.purchasedFrom?.idNumber || ''}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, ''); // Sadece sayı
                                            const maxLength = data.supplierIdentityType === 'TCKN' ? 11 : 10;
                                            if (value.length <= maxLength) {
                                                const event = {
                                                    target: {
                                                        name: 'purchasedFrom.idNumber',
                                                        value: value
                                                    }
                                                };
                                                handleChange(event);
                                                // Hataları temizle
                                                // setSupplierSearchError(''); // Bu props varsa
                                                // setFoundSupplier(null);   // Bu props varsa
                                            }
                                        }}
                                        maxLength={data.supplierIdentityType === 'TCKN' ? 11 : 10}
                                        placeholder={data.supplierIdentityType === 'TCKN' ? '12345678901 (11 hane)' : '1234567890 (10 hane)'}
                                        className={`${getFieldClasses('purchasedFrom.idNumber')} ${foundSupplier ? "is-valid" : supplierSearchError ? "is-invalid" : ""}`}

                                        required
                                    />
                                    <Button
                                        variant={foundSupplier ? "outline-success" : supplierSearchError ? "outline-danger" : "outline-primary"}
                                        onClick={handleSearchSupplier}
                                        disabled={(data.purchasedFrom?.idNumber?.length || 0) < 10 || searchingSupplier}
                                        title={foundSupplier ? "Tedarikçi bulundu" : supplierSearchError ? "Tedarikçi bulunamadı" : "Bu kimlik ile tedarikçi ara"}
                                    >
                                        {searchingSupplier ? (
                                            <Spinner size="sm" animation="border" />
                                        ) : foundSupplier ? (
                                            '✅'
                                        ) : supplierSearchError ? (
                                            '⚠️'
                                        ) : (
                                            '🔍'
                                        )}
                                    </Button>
                                </div>
                                {supplierSearchError && (
                                    <div className="invalid-feedback">
                                        {supplierSearchError}
                                    </div>
                                )}
                                <Form.Text className="text-muted">
                                    {data.supplierIdentityType === 'TCKN'
                                        ? 'T.C. Kimlik Numarası 11 haneli olmalıdır'
                                        : 'Vergi Kimlik Numarası 10 haneli olmalıdır'
                                    }
                                </Form.Text>
                            </Form.Group>
                        </Col>

                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>Telefon</Form.Label>
                                <Form.Control
                                    type="tel"
                                    name="purchasedFrom.phone"
                                    value={data.purchasedFrom?.phone || ''}
                                    onChange={handleChange}
                                    placeholder="0555 123 45 67"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>E-posta</Form.Label>
                                <Form.Control
                                    type="email"
                                    name="purchasedFrom.email"
                                    value={data.purchasedFrom?.email || ''}
                                    onChange={handleChange}
                                    placeholder="ornek@email.com"
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Adres</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="purchasedFrom.address"
                                    value={data.purchasedFrom?.address || ''}
                                    onChange={(e) => {
                                        const value = e.target.value.toUpperCase();
                                        handleChange({
                                            target: {
                                                name: 'purchasedFrom.address',
                                                value: value
                                            }
                                        });
                                    }}
                                    placeholder="Satıcı adresi"
                                    className={getFieldClasses('purchasedFrom.address')}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </div>

                {/* ✅ Alıcı Bilgileri - Compact & Optional */}
                <div className="border-top pt-3">
                    <h6 className="mb-3">🤝 Alıcı Bilgileri (Kime Satıldı) - İsteğe Bağlı</h6>

                    {/* *** YENİ: Customer Kimlik Türü Seçimi *** */}
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">Kimlik Türü</Form.Label>
                        <div className="d-flex gap-3 mt-2">
                            <Form.Check
                                type="radio"
                                id="customer-identity-tckn"
                                name="customerIdentityType"
                                label="T.C. Kimlik No"
                                checked={data.customerIdentityType === 'TCKN'}
                                onChange={() => {
                                    const event = { target: { name: 'customerIdentityType', value: 'TCKN' } };
                                    handleChange(event);
                                }}
                            />
                            <Form.Check
                                type="radio"
                                id="customer-identity-vkn"
                                name="customerIdentityType"
                                label="Vergi Kimlik No"
                                checked={data.customerIdentityType === 'VKN'}
                                onChange={() => {
                                    const event = { target: { name: 'customerIdentityType', value: 'VKN' } };
                                    handleChange(event);
                                }}
                            />
                        </div>
                    </Form.Group>

                    <Row>
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>Alıcı Adı</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="soldTo.name"
                                    value={data.soldTo?.name || ''}
                                    onChange={(e) => {
                                        const value = e.target.value.toUpperCase();
                                        handleChange({
                                            target: {
                                                name: 'soldTo.name',
                                                value: value
                                            }
                                        });
                                    }}
                                    placeholder="Alıcı/Firma adı"
                                    className={getFieldClasses('soldTo.name')}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    {data.customerIdentityType === 'TCKN' ? 'T.C. Kimlik No' : 'Vergi Kimlik No'}
                                </Form.Label>
                                <div className="d-flex gap-2">
                                    <Form.Control
                                        type="text"
                                        value={data.soldTo?.idNumber || ''}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, ''); // Sadece sayı
                                            const maxLength = data.customerIdentityType === 'TCKN' ? 11 : 10;                                            if (value.length <= maxLength) {
                                                const event = {
                                                    target: {
                                                        name: 'soldTo.idNumber',
                                                        value: value
                                                    }
                                                };
                                                handleChange(event);
                                            }
                                        }}
                                        maxLength={data.customerIdentityType === 'TCKN' ? 11 : 10}
                                        placeholder={data.customerIdentityType === 'TCKN' ? '12345678901 (11 hane)' : '1234567890 (10 hane)'}
                                        className={`${getFieldClasses('soldTo.idNumber')} ${foundCustomer ? "is-valid" : customerSearchError ? "is-invalid" : ""}`}

                                    />
                                    <Button
                                        variant={foundCustomer ? "outline-success" : customerSearchError ? "outline-danger" : "outline-success"}
                                        onClick={handleSearchCustomer}
                                        disabled={(data.soldTo?.idNumber?.length || 0) < 10 || searchingCustomer}
                                        title={foundCustomer ? "Müşteri bulundu" : customerSearchError ? "Müşteri bulunamadı" : "Bu kimlik ile müşteri ara"}
                                    >
                                        {searchingCustomer ? (
                                            <Spinner size="sm" animation="border" />
                                        ) : foundCustomer ? (
                                            '✅'
                                        ) : customerSearchError ? (
                                            '⚠️'
                                        ) : (
                                            '🔍'
                                        )}
                                    </Button>
                                </div>
                                {customerSearchError && (
                                    <div className="invalid-feedback">
                                        {customerSearchError}
                                    </div>
                                )}
                                <Form.Text className="text-muted">
                                    {data.customerIdentityType === 'TCKN'
                                        ? 'T.C. Kimlik Numarası 11 haneli olmalıdır'
                                        : 'Vergi Kimlik Numarası 10 haneli olmalıdır'
                                    }
                                </Form.Text>
                            </Form.Group>
                        </Col>

                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>Telefon</Form.Label>
                                <Form.Control
                                    type="tel"
                                    name="soldTo.phone"
                                    value={data.soldTo?.phone || ''}
                                    onChange={handleChange}
                                    placeholder="0555 123 45 67"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>E-posta</Form.Label>
                                <Form.Control
                                    type="email"
                                    name="soldTo.email"
                                    value={data.soldTo?.email || ''}
                                    onChange={handleChange}
                                    placeholder="ornek@email.com"
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Adres</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="soldTo.address"
                                    value={data.soldTo?.address || ''}
                                    onChange={(e) => {
                                        const value = e.target.value.toUpperCase();
                                        handleChange({
                                            target: {
                                                name: 'soldTo.address',
                                                value: value
                                            }
                                        });
                                    }}
                                    placeholder="Alıcı adresi"
                                    className={getFieldClasses('soldTo.address')}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </div>
            </Card.Body>
        </Card>
    );
};

export default VehiclePriceForm;